import React from 'react';

const ProgressBar = ({ value, max, label, colorClass }) => {
    const percentage = (value / max) * 100;
    return (
        <div className="w-full">
            <div className="flex justify-between items-center mb-1">
                <span className="text-xs font-semibold text-gray-300">{label}</span>
                <span className="text-xs font-semibold text-gray-300">{value} / {max}</span>
            </div>
            <div className="w-full bg-gray-700 rounded-full h-2.5">
                <div className={`${colorClass} h-2.5 rounded-full`} style={{ width: `${percentage}%` }}></div>
            </div>
        </div>
    );
};

export default ProgressBar;